<ng-template #editableTemplateRef
             let-rowData="rowData">
  <p-radioButton [name]="tableColumn.field"
                 [value]="rowData[keyFieldName]"
                 [ngModel]="rowSelection"
                 (ngModelChange)="onRowSelectionChange(rowData, $event)"></p-radioButton>
</ng-template>